import { create } from "zustand";

interface OrgState {
  activeOrgId: string;
  activeRole: string;
  orgs: Record<string, string>;
  setOrgData: (orgs: Record<string, string>, activeOrgId: string) => void;
  setActiveOrgId: (orgId: string) => void;
  reset: () => void;
}

export const useOrgStore = create<OrgState>((set, get) => ({
  activeOrgId: "",
  activeRole: "",
  orgs: {},

  setOrgData: (orgs, activeOrgId) => {
    // If the provided activeOrgId isn't in the orgs list, fallback to the first one available
    let resolvedOrgId = activeOrgId;
    if (!resolvedOrgId || !orgs[resolvedOrgId]) {
      resolvedOrgId = Object.keys(orgs)[0] || "";
    }

    set({
      orgs,
      activeOrgId: resolvedOrgId,
      activeRole: resolvedOrgId ? orgs[resolvedOrgId] : "",
    });
  },

  setActiveOrgId: (orgId: string) => {
    const orgs = get().orgs;
    if (orgs[orgId]) {
      set({
        activeOrgId: orgId,
        activeRole: orgs[orgId],
      });
    }
  },

  reset: () => {
    set({ activeOrgId: "", activeRole: "", orgs: {} });
  },
}));

// Provide a non-hook way to get the active org ID for apiClient
export const getActiveOrgId = () => useOrgStore.getState().activeOrgId;
